<template>
  <div class="thumb-row">
    <thumbnail
      v-for="(image, index) in images"
      :key="image.imgKey"
      :image="image"
      :index="index"
      :isCirrus="isCirrus"
      :isUserPrefBlackAndWhiteCirrusView="isUserPrefBlackAndWhiteCirrusView"
      :isMultiview="false"
      @click="selectImage(image)" />
  </div>
</template>

<script>
import thumbnail from "../misc/Thumbnail";
import { logDetailed, sortImagesByTimespan, getsortedImages } from "../../helpers/utils.js";
export default {
  name: "PatientExamImageThumbRow",
  components: {
    thumbnail,
  },
  props: {
    exam: Object,
  },
  computed: {
    images() {
      return sortImagesByTimespan(
         getsortedImages(this.$store.getters.imagesByExSrNo(this.exam.exSrNo), this.$store.getters.imagesOrderByExSrNo(this.exam.exSrNo))
      );
    },
    isIE() {
      return this.$store.getters.isIE;
    },
    isCirrus() {
      return this.exam.browserType == "Cirrus";
    },
    isUserPrefBlackAndWhiteCirrusView() {
      return this.$store.getters.userPrefBlackAndWhiteCirrusView
    },
  },
  methods: {
    selectImage(image) {
      this.$store.dispatch("openBrowserForImage", image);
    },
  },
  watch: {
    // Fetches thumbnail images for exam that had images added to it via manual upload
    images() {
      this.$store.dispatch("getThumbnailsForOpenExams");
    },
  },
  mounted() {
    logDetailed("patientExamImageThumbRow", "mounted", this.exam);
    this.$store.dispatch("loadExamImageMetadata", {exSrNos: [this.exam.exSrNo]});
  },
};
</script>
